//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "MABL",
  data() {
    return {
      defaultJson: {
        Patient5: "成年女性（65 mL/kg）",
        "Patient5 (short)": "65 mL/kg",
        "Starting Hct": "术前的 Hct",
        Patient1: "早产儿（95 mL/kg）",
        Weight: "体重",
        "Allowable Loss": "允许失血量",
        "Avg Blood Volume": "平均血容量",
        Patient2: "足月儿（85 mL/kg）",
        Patient3: "幼儿（80 mL/kg）",
        "Est. Blood Vol.": "估计血容量",
        "Patient3 (short)": "80 mL/kg",
        "Average blood volume": "平均血容量",
        Patient4: "成年男性（75 mL/kg）",
        "Patient4 (short)": "75 mL/kg",
        "Allowable Hct": "现在的 Hct",
        "Patient1 (short)": "95 mL/kg",
        "Patient2 (short)": "85 mL/kg",
      },
      form: {
        sHct: "",
        aHct: "",
        w: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0.095", name: "新生儿（85 mL/kg）", shortName: "985 mL/kg" },
        { value: "0.075", name: "成年男性（75 mL/kg）", shortName: "75 mL/kg" },
        { value: "0.065", name: "成年女性（65 mL/kg）", shortName: "65 mL/kg" },
      ],
      allowable_display: "...",
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        self.allowable_display = "...";
        return "...";
      } else {
        let result = (70 * form.w * ((form.sHct - form.aHct) / form.sHct)).toFixed(0)

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/MABL.vue